import { styled, typography } from '@pulse-web-ui/theme';

export const ValidationError = styled.p`
  ${typography.regular14};
  margin-bottom: 4px;
  white-space: pre-line;
  color: ${({ theme }) => theme.colors.text.error};
`;
